module.exports = __webpack_public_path__ + "static/fonts/342F4F_6_0.89e793e.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_6_0.woff
// module id = 110
// module chunks = 3